<pgh-modal-window class="get-start-modal w-100">
  <div modal-close class="close-button-container">
    <button type="button"  class="close-button " sf-aria-label="Global_Close_Window" matDialogClose>
      <adp-label class="close-label" labelKey="Global_Button_Close"></adp-label>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <adp-setting key="Tutorial_Panels_PTP_Primary"></adp-setting>
  <adp-setting key="Tutorial_Panels_PTP_Secondary"></adp-setting>
  <adp-setting key="Tutorial_Panels_Primary"></adp-setting>
  <adp-setting key="Tutorial_Panels_Secondary"></adp-setting>



  <div modal-body class="modal-body">
    <div id="getStartedCarousel" #tutorialCarousel class="carousel slide carousel-fade" data-bs-interval="false" data-bs-ride="carousel">

      <div class="carousel-inner">

        <div class="carousel-item" *ngFor="let key of tutorialPanels;let k = index;" [ngClass]="k == 0 ? 'active' : ''" [gaName]="'Get Started ' + key">
          <adp-image imageClass="d-none d-lg-block" [imageKey]="'Global_' + key + '_Image'"></adp-image>
          <adp-image imageClass="d-block d-lg-none" [imageKey]="'Global_' + key + '_MobileImage'"></adp-image>
          <div class="text-container">
            <h4 modal-title class="u-heading-4">
              <adp-label [labelKey]="key + '_Heading'"></adp-label>
            </h4>
            <p>
              <adp-label [labelKey]="key"></adp-label>
            </p>
          </div>

        </div>

      </div>
      <div class="carousel-indicators">
        <button type="button" data-bs-target="#getStartedCarousel" *ngFor="let key of tutorialPanels;let i=index;"
          [attr.data-bs-slide-to]="i" [ngClass]="i == 0 ? 'active' : ''" [attr.aria-label]='"Show slide " + (i+1) + " of " + tutorialPanels.length'></button>
      </div>
      <button class="carousel-control-next" type="button" data-bs-target="#getStartedCarousel" data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.49902 28C9.29902 28 9.11002 27.922 8.96902 27.78C8.67702 27.488 8.67702 27.012 8.96902 26.719L19.689 16L8.96902 5.28C8.82702 5.139 8.74902 4.95 8.74902 4.75C8.74902 4.55 8.82702 4.361 8.96902 4.22C9.11002 4.078 9.29902 4 9.49902 4C9.69902 4 9.88802 4.078 10.029 4.22L20.749 14.94C21.333 15.524 21.334 16.475 20.75 17.059L10.029 27.78C9.88802 27.922 9.69902 28 9.49902 28Z" fill="#3C4D6A"/>
          </svg>
          </span>
        <span class="visually-hidden"> <adp-label labelKey="Global_Button_Next"></adp-label></span>
      </button>
    </div>
  </div>
  <div modal-footer class="footer">
    <div class="col-6">
      <button mat-flat-button color="accent" (click)="closeModal()" >
        <adp-label labelKey="Tutorial_Panels_Footer_Button_Label"></adp-label>
      </button>
    </div>
  </div>
</pgh-modal-window>
